import { identity } from "@suse-o11y/identity";
import { isPresent } from "@suse-o11y/is-present";
import { createSelector } from "reselect";

import { Api } from "../../../../common/openapi";
import { createDeepEqualSelector } from "../../../../generic/redux/SelectorUtils";
import type { TimelineSummaryRequestWithTimeRange } from "../../../../queries/timeline";
import { selectDefaultQueryVersion } from "../../config/ConfigSelectors";
import type { RootState } from "../../RootState";
import { selectAllSearchParams, selectComponentIdentifier } from "../../route/RouteSelectors";
import { selectTimeRange, selectTimestampDate } from "../timeline/TimelineSelectors";

import { forValidatedQuery } from "./ViewPointHelpers";

const passQuery = (_: RootState, query: string) => query;

export const selectDetachedFilters = createDeepEqualSelector(
	createSelector(selectAllSearchParams, ({ detachedFilters }) => detachedFilters),
	identity,
);

export const selectIsExploreSubview = createSelector(selectAllSearchParams, ({ explore }) => isPresent(explore));
export const selectIsCustomQueryView = createSelector(selectAllSearchParams, ({ query }) => isPresent(query));

export const selectQuerySummaryRequest = createSelector(
	[
		selectDefaultQueryVersion,
		selectTimeRange,
		selectIsExploreSubview,
		selectComponentIdentifier,
		selectTimestampDate,
		passQuery,
	],
	(
		queryVersion,
		timeRange,
		isSubview,
		componentIdentifier,
		timestamp,
		query,
	): undefined | TimelineSummaryRequestWithTimeRange => {
		if (componentIdentifier && !isSubview) {
			return {
				arguments: {
					_type: Api.ComponentViewArguments.TypeEnum.ComponentViewArguments,
					componentIdentifier,
					queryTime: timestamp?.getTime(),
				},
				timeRange,
			};
		}

		return forValidatedQuery(query, (validQuery) => ({
			arguments: {
				_type: Api.QueryViewArguments.TypeEnum.QueryViewArguments,
				query: validQuery,
				queryVersion,
				queryTime: timestamp?.getTime(),
			},
			timeRange,
		}));
	},
);
